var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.masterAdmin ? _c("masteradmin-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c(
              "div",
              { staticClass: "container-wrapper center" },
              [
                _c("div", [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v("Affiliate")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-red btn-md input-height-15 float-right text-align-right",
                      on: {
                        click: function($event) {
                          ;(_vm.isModalVisible = true), _vm.verrors.clear()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus spacer-icon",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("Affiliate")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        " btn btn-red btn-md input-height-15 float-right ",
                      staticStyle: { "margin-right": "20px" },
                      on: {
                        click: function($event) {
                          _vm.fetchIndustriesLists(),
                            (_vm.isIndustryModalVisible = true),
                            (_vm.industryLoading = true),
                            _vm.verrors.clear(),
                            (_vm.industry = "")
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus spacer-icon",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("Industries\n          ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "heading-seperator" }),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("div", { staticClass: "row tasks_heading_row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-5 col-lg-5 col-md-5 col-sm-4 col-4",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("name")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Affiliate\n                "
                              ),
                              _vm.publicSortField == "name" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.publicSortField == "name" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("status")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Status\n                "
                              ),
                              _vm.publicSortField == "status" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.publicSortField == "status" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                # of Task Lists\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("createdBy")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Created By\n                "
                              ),
                              _vm.publicSortField == "createdBy" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.publicSortField == "createdBy" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ],
                            staticClass: "loading_show"
                          },
                          [
                            _c("div", {
                              staticClass: "spinner-border text-danger"
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.affiliatelists.length > 0
                          ? _c(
                              "b-card-text",
                              [
                                _vm._l(_vm.affiliatelists, function(
                                  affiliatelist,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "tasklists-row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "row tasklist-item",
                                          staticStyle: { margin: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-5 col-lg-5 col-md-5 col-sm-4 col-4"
                                            },
                                            [
                                              _vm._v(
                                                "\n                   " +
                                                  _vm._s(affiliatelist.name) +
                                                  "\n                 "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(affiliatelist.status)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "link col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    affiliatelist.tasklists_count
                                                  ) +
                                                  "\n                    "
                                              ),
                                              affiliatelist.tasklists_count > 0
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-dark-grey in-use-button override-padding",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.viewTaskLists(
                                                            affiliatelist.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("View")]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(affiliatelist.created_by)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown",
                                                  attrs: {
                                                    id:
                                                      "dropdown-container" +
                                                      index
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleDropdown(
                                                        "actionDropdown" +
                                                          index +
                                                          ""
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "dropbtn icons btn-right showLeft",
                                                      attrs: {
                                                        id:
                                                          "dotted-menu" + index
                                                      }
                                                    },
                                                    [
                                                      _c("li"),
                                                      _vm._v(" "),
                                                      _c("li"),
                                                      _vm._v(" "),
                                                      _c("li")
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-content",
                                                      attrs: {
                                                        id:
                                                          "actionDropdown" +
                                                          index
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "action-dd-menu",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.goToEdit(
                                                                affiliatelist
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "cursor-pointer fa fa-edit spacer-icon"
                                                          }),
                                                          _vm._v("Edit")
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      affiliatelist.status ===
                                                      "Active"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "action-dd-menu",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.viewAccount(
                                                                    affiliatelist.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-user-o spacer-icon"
                                                              }),
                                                              _vm._v(
                                                                "View account"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [_c("hr")])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.rows > 25
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "overflow-auto float-right pagination-wrapper"
                                      },
                                      [
                                        _c("b-pagination", {
                                          attrs: {
                                            "total-rows": _vm.rows,
                                            "per-page": _vm.perPage,
                                            "first-text": "First",
                                            "prev-text": "Prev",
                                            "next-text": "Next",
                                            "last-text": "Last",
                                            "hide-goto-end-buttons": true
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.showAffiliateofPaginated()
                                            }
                                          },
                                          model: {
                                            value: _vm.currentPage,
                                            callback: function($$v) {
                                              _vm.currentPage = $$v
                                            },
                                            expression: "currentPage"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm.loading == false
                          ? _c("b-card-text", [
                              _vm._v(
                                "\n                 No affiliate found.\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "CreateTasklistModal",
                  {
                    attrs: { isModalVisible: _vm.isModalVisible },
                    on: {
                      close: function($event) {
                        _vm.isModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_c("h3", [_vm._v("Create Affiliate")])]
                    ),
                    _vm._v(" "),
                    _vm.isModalVisible === true
                      ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                          _c(
                            "div",
                            { staticClass: "col-11 override-padding" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.affiliate_name,
                                    expression: "affiliate_name"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "col-lg-11 input-height-25",
                                attrs: {
                                  name: "affiliate_name",
                                  placeholder: "Enter Affiliate Name",
                                  maxlength: "255"
                                },
                                domProps: { value: _vm.affiliate_name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.affiliate_name = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "affiliate_name",
                                "required"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Affiliate name is required")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "affiliate_name",
                                "exists"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Affiliate name already exists")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-11 override-padding" },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass:
                                  "col-lg-9 col-sm-9 col-8 input-height-15",
                                staticStyle: { height: "30px" },
                                attrs: {
                                  name: "affiliate_status",
                                  options: _vm.affiliate_status_options
                                },
                                model: {
                                  value: _vm.affiliate_status,
                                  callback: function($$v) {
                                    _vm.affiliate_status = $$v
                                  },
                                  expression: "affiliate_status"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-red col-lg-2 col-sm-2 col-3 input-height-25",
                                  on: {
                                    click: function($event) {
                                      return _vm.createAffiliate()
                                    }
                                  }
                                },
                                [_c("b", [_vm._v("Create")])]
                              ),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "affiliate_status",
                                "required"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Affiliate status is required")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "EditTasksModal",
                  {
                    attrs: {
                      isModalVisible: _vm.isEditModalVisible,
                      editTaskTitle: _vm.editAffiliateName,
                      editTaskPriority: _vm.editAffiliateStatus,
                      editTaskId: _vm.editAffiliateId
                    },
                    on: {
                      close: function($event) {
                        _vm.isEditModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_c("h3", [_vm._v("Update Affiliate")])]
                    ),
                    _vm._v(" "),
                    _vm.isEditModalVisible === true
                      ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 override-padding" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editAffiliateName,
                                    expression: "editAffiliateName"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                ref: "editAffiliateName",
                                staticClass: "col-12 input-height-25",
                                attrs: {
                                  name: "editAffiliateName",
                                  id: "editAffiliateName",
                                  placeholder: "Enter Affiliate Name",
                                  maxlength: "255"
                                },
                                domProps: { value: _vm.editAffiliateName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.editAffiliateName = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "editAffiliateName",
                                "required"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Affiliate name is required")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 override-padding" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-9 col-12 float-left override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-9 col-sm-9 col-8 input-height-15",
                                    staticStyle: { height: "30px" },
                                    attrs: {
                                      name: "editAffiliateStatus",
                                      options: _vm.affiliate_status_options
                                    },
                                    model: {
                                      value: _vm.editAffiliateStatus,
                                      callback: function($$v) {
                                        _vm.editAffiliateStatus = $$v
                                      },
                                      expression: "editAffiliateStatus"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-red col-3 float-left input-height-25",
                                  staticStyle: { margin: "0px 0px 0px 0px" },
                                  on: {
                                    click: function($event) {
                                      return _vm.updateAffiliateAction(
                                        _vm.editAffiliateId
                                      )
                                    }
                                  }
                                },
                                [_c("b", [_vm._v("Update")])]
                              ),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "editAffiliateStatus",
                                "required"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Affiliate status is required")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "TaskListModal",
                  {
                    attrs: { isModalVisible: _vm.isTaskListModalVisible },
                    on: {
                      close: function($event) {
                        _vm.isTaskListModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "Following tasklists are associated with this affiliate :"
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(_vm.tasklist_lists, function(tasklist_list) {
                            return _c("li", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(tasklist_list.name) +
                                  "\n              "
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "CreateIndustriesModal",
                  {
                    attrs: { isModalVisible: _vm.isIndustryModalVisible },
                    on: {
                      close: function($event) {
                        _vm.isIndustryModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n      Loading...\n    ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_c("h3", [_vm._v("Industries")])]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-9 override-padding float-left" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.industry,
                                  expression: "industry"
                                }
                              ],
                              staticClass: "col-lg-12 input-text form-control",
                              staticStyle: { "line-height": "30px" },
                              attrs: {
                                name: "industry",
                                placeholder: "Enter Industry Type",
                                maxlength: "140"
                              },
                              domProps: { value: _vm.industry },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.industry = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-blue col-12",
                                staticStyle: {
                                  "line-height": "30px",
                                  "margin-left": "15px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.createIndustry()
                                  }
                                }
                              },
                              [_c("b", [_vm._v("Create")])]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.industryLoading,
                              expression: "industryLoading"
                            }
                          ],
                          staticClass: "loading_show"
                        },
                        [
                          _c("div", {
                            staticClass: "spinner-border text-danger"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.industryLoading == false
                        ? _c(
                            "div",
                            {
                              staticClass: "col-12 override-padding",
                              staticStyle: { "margin-top": "30px" }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { margin: "bottom: 15px" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "bold float-left",
                                      staticStyle: {
                                        width: "70%",
                                        color: "#9B9B9B"
                                      }
                                    },
                                    [_vm._v("Industry Type")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "bold float-left",
                                      staticStyle: { width: "20%" }
                                    },
                                    [_vm._v(" ")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticStyle: { clear: "both" } })
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.industry_lists, function(list, index) {
                                return _c(
                                  "div",
                                  { staticStyle: { margin: "bottom: 10px" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left",
                                        staticStyle: {
                                          width: "70%",
                                          color: "#9B9B9B"
                                        }
                                      },
                                      [_vm._v(_vm._s(list.title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "float-left",
                                        staticStyle: { width: "20%" },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteIndustriesConfirm(
                                              list.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-times custom-remove",
                                          staticStyle: { cursor: "pointer" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { clear: "both" }
                                    })
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.industry_lists.length == 0
                                ? _c(
                                    "div",
                                    { staticStyle: { "padding-top": "40px" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "float-left",
                                          staticStyle: {
                                            width: "90%",
                                            color: "#9B9B9B"
                                          }
                                        },
                                        [_vm._v("No Industries to display")]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "DeleteIndustriesModal",
                  {
                    attrs: {
                      isModalVisible: _vm.isDeleteIndustriesModalVisible,
                      id: _vm.industry_id
                    },
                    on: {
                      close: function($event) {
                        _vm.isDeleteIndustriesModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n      Loading...\n    ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_vm._v("Are you sure you want to delete?")]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-3 override-padding",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "left col-12 btn btn-red",
                            on: {
                              click: function($event) {
                                return _vm.deleteIndustries(_vm.industry_id)
                              }
                            }
                          },
                          [_vm._v("Confirm")]
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e17358a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e17358a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/view_affiliate_list.vue
// module id = null
// module chunks = 